import { isStringNullOrWhiteSpace } from 'owa-strings';

/**
 * Code here is based on JSMVVM transpiled JavaScript
 */

/**
 * Parses and validates a given address per the rules specified in RFC821
 * @param address
 * @returns whether valid
 */
export function isValidAddress(address: string) {
    const [isValid] = IsValidSmtpAddress(address, true, true);
    return isValid;
}

/**
 * Parses and validates a given address per the rules specified in RFC821
 * @param address
 * @returns whether valid
 */
export function isValidAddressDomain(address: string): boolean {
    return IsValidDomain(address, 0, true, true);
}

const enum Token {
    /// <summary>MIME control character.</summary>
    Ctl = 1,

    /// <summary>MIME SPEC character.</summary>
    Spec = 2,

    /// <summary>MIME TSPEC character.</summary>
    TSpec = 4,

    /// <summary>MIME token character.</summary>
    Token = 8,

    /// <summary>MIME atom character.</summary>
    Atom = 16,

    /// <summary>Digit character.</summary>
    Digit = 32,

    /// <summary>Hexadecimal character.</summary>
    Hex = 64,

    /// <summary>Linear white space character.</summary>
    Lwsp = 128,

    /// <summary>Binary character.</summary>
    BChar = 256,

    /// <summary>Field character.</summary>
    Field = 512,

    /// <summary>Field character.</summary>
    Alpha = 1024,

    /// <summary>Folding white space character.</summary>
    Fwsp = 2048,
}

const enum ValidationStage {
    /// <summary>BEGIN</summary>
    BEGIN = 0,

    /// <summary>ELOCALND</summary>
    LOCAL = 1,

    /// <summary>LOCAL_DOT</summary>
    LOCAL_DOT = 2,

    /// <summary>LOCAL_DQS</summary>
    LOCAL_DQS = 3,

    /// <summary>LOCAL_ESC</summary>
    LOCAL_ESC = 4,

    /// <summary>LOCAL_DQS_ESC</summary>
    LOCAL_DQS_ESC = 5,

    /// <summary>LOCAL_DQS_END</summary>
    LOCAL_DQS_END = 6,

    /// <summary>DOMAIN</summary>
    DOMAIN = 7,

    /// <summary>DOMAIN_SUB</summary>
    DOMAIN_SUB = 8,

    /// <summary>DOMAIN_DOT</summary>
    DOMAIN_DOT = 9,

    /// <summary>DOMAIN_LITERAL</summary>
    DOMAIN_LITERAL = 10,

    /// <summary>DOMAIN_LITERAL_IPV4</summary>
    DOMAIN_LITERAL_IPV4 = 11,

    /// <summary>DOMAIN_LITERAL_IPV4_DOT</summary>
    DOMAIN_LITERAL_IPV4_DOT = 12,

    /// <summary>DOMAIN_LITERAL_I</summary>
    DOMAIN_LITERAL_I = 13,

    /// <summary>DOMAIN_LITERAL_IP</summary>
    DOMAIN_LITERAL_IP = 14,

    /// <summary>DOMAIN_LITERAL_IPV</summary>
    DOMAIN_LITERAL_IPV = 15,

    /// <summary>DOMAIN_LITERAL_IPV6</summary>
    DOMAIN_LITERAL_IPV6 = 16,

    /// <summary>DOMAIN_LITERAL_IPV6_</summary>
    DOMAIN_LITERAL_IPV6_ = 17,

    /// <summary>DOMAIN_LITERAL_IPV6_STARTCOLON</summary>
    DOMAIN_LITERAL_IPV6_STARTCOLON = 18,

    /// <summary>DOMAIN_LITERAL_IPV6_GRP</summary>
    DOMAIN_LITERAL_IPV6_GRP = 19,

    /// <summary>DOMAIN_LITERAL_IPV6_V4GRP</summary>
    DOMAIN_LITERAL_IPV6_V4GRP = 20,

    /// <summary>DOMAIN_LITERAL_IPV6_COLON</summary>
    DOMAIN_LITERAL_IPV6_COLON = 21,

    /// <summary>DOMAIN_LITERAL_IPV6_COMP</summary>
    DOMAIN_LITERAL_IPV6_COMP = 22,

    /// <summary>DOMAIN_LITERAL_END</summary>
    DOMAIN_LITERAL_END = 23,

    /// <summary>ERROR</summary>
    ERROR = 24,
}

const Dictionary: Token[] = [
    Token.Ctl /* 00 (NUL) */,
    Token.Ctl /* 01 (SOH) */,
    Token.Ctl /* 02 (STX) */,
    Token.Ctl /* 03 (ETX) */,
    Token.Ctl /* 04 (EOT) */,
    Token.Ctl /* 05 (ENQ) */,
    Token.Ctl /* 06 (ACK) */,
    Token.Ctl /* 07 (BEL) */,
    Token.Ctl /* 08 (BS) */,
    Token.Ctl | Token.Lwsp | Token.Fwsp /* 09 (HT) */,
    Token.Ctl | Token.Lwsp /* 0A (LF)*/,
    Token.Ctl /* 0B (VT) */,
    Token.Ctl /* 0C (FF) */,
    Token.Ctl | Token.Lwsp /* 0D (CR) */,
    Token.Ctl /* 0E (SI) */,
    Token.Ctl /* 0F (SO) */,
    Token.Ctl /* 10 (DLE) */,
    Token.Ctl /* 11 (DC1) */,
    Token.Ctl /* 12 (DC2) */,
    Token.Ctl /* 13 (DC3) */,
    Token.Ctl /* 14 (DC4) */,
    Token.Ctl /* 15 (NAK) */,
    Token.Ctl /* 16 (SYN) */,
    Token.Ctl /* 17 (ETB) */,
    Token.Ctl /* 18 (CAN) */,
    Token.Ctl /* 19 (EM) */,
    Token.Ctl /* 1A (SUB) */,
    Token.Ctl /* 1B (ESC) */,
    Token.Ctl /* 1C (FS) */,
    Token.Ctl /* 1D (GS) */,
    Token.Ctl /* 1E (RS) */,
    Token.Ctl /* 1F (US) */,
    Token.Lwsp | Token.Fwsp | Token.BChar /* 20 SPACE */,
    Token.Field | Token.Atom | Token.Token /* 21 ! */,
    Token.Field | Token.Spec | Token.TSpec /* 22 " */,
    Token.Field | Token.Atom | Token.Token /* 23 # */,
    Token.Field | Token.Atom | Token.Token /* 24 $ */,
    Token.Field | Token.Atom | Token.Token /* 25 % */,
    Token.Field | Token.Atom | Token.Token /* 26 & */,
    Token.Field | Token.Atom | Token.Token | Token.BChar /* 27 ' */,
    Token.Field | Token.Spec | Token.TSpec | Token.BChar /* 28 ( */,
    Token.Field | Token.Spec | Token.TSpec | Token.BChar /* 29 ) */,
    Token.Field | Token.Atom | Token.Token /* 2A * */,
    Token.Field | Token.Atom | Token.Token | Token.BChar /* 2B | */,
    Token.Field | Token.Spec | Token.TSpec | Token.BChar /* 2C , */,
    Token.Field | Token.Atom | Token.Token | Token.BChar /* 2D - */,
    Token.Field | Token.Token | Token.Spec | Token.BChar /* 2E . */,
    Token.Field | Token.Atom | Token.TSpec | Token.BChar /* 2F / */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 30 0 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 31 1 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 32 2 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 33 3 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 34 4 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 35 5 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 36 6 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 37 7 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 38 8 */,
    Token.Field | Token.Atom | Token.Token | Token.Digit | Token.Hex | Token.BChar /* 39 9 */,
    Token.Spec | Token.TSpec | Token.BChar /* 3A : */,
    Token.Field | Token.Spec | Token.TSpec /* 3B ; */,
    Token.Field | Token.Spec | Token.TSpec /* 3C < */,
    Token.Field | Token.Atom | Token.TSpec | Token.BChar /* 3D = */,
    Token.Field | Token.Spec | Token.TSpec /* 3E > */,
    Token.Field | Token.Atom | Token.TSpec | Token.BChar /* 3F ? */,
    Token.Field | Token.Spec | Token.TSpec /* 40 @ */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 41 A */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 42 B */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 43 C */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 44 D */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 45 E */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 46 F */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 47 G */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 48 H */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 49 I */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 4A J */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 4B K */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 4C L */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 4D M */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 4E N */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 4F O */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 50 P */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 51 Q */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 52 R */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 53 S */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 54 T */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 55 U */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 56 V */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 57 W */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 58 X */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 59 Y */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 5A Z */,
    Token.Field | Token.Spec | Token.TSpec /* 5B [ */,
    Token.Field | Token.Spec | Token.TSpec /* 5C \ */,
    Token.Field | Token.Spec | Token.TSpec /* 5D ] */,
    Token.Field | Token.Atom | Token.Token /* 5E ^ */,
    Token.Field | Token.Atom | Token.Token | Token.BChar /* 5F _ */,
    Token.Field | Token.Atom | Token.Token /* 60 ` */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 61 a */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 62 b */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 63 c */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 64 d */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 65 e */,
    Token.Field | Token.Atom | Token.Token | Token.Hex | Token.BChar | Token.Alpha /* 66 f */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 67 g */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 68 h */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 69 i */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 6A j */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 6B k */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 6C l */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 6D m */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 6E n */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 6F o */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 70 p */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 71 q */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 72 r */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 73 s */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 74 t */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 75 u */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 76 v */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 77 w */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 78 x */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 79 y */,
    Token.Field | Token.Atom | Token.Token | Token.BChar | Token.Alpha /* 7A z */,
    Token.Field | Token.Atom | Token.Token /* 7B { */,
    Token.Field | Token.Atom | Token.Token /* 7C | */,
    Token.Field | Token.Atom | Token.Token /* 7D } */,
    Token.Field | Token.Atom | Token.Token /* 7E ~ */,
    Token.Ctl /* 7F (DEL) */ /* 80 - FF */,
    /* and the rest are zero's */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
];

/**
 * Maximum length for an email name
 */
const MaxEmailName = 315; // for compatibility with TI, which accepts local part up to 315 chars, see PS:Exchange12:7056

/**
 * Maximum length for an email name for IMCEA-encapsulated X400 addresses.
 * Coupled with '@' and MaxDomainName, this results in max full address.
 * Coupled with '@' and MaxDomainName, this results in max full address.
 */
const MaxX400EmailName = 1604;

/**
 * Maximum length for a domain name
 */
const MaxDomainName = 255;

/**
 * Maximum length for a subdomain name
 * Labels must be 63 characters or less.
 */
const MaxSubDomainName = 63;

/**
 * Maximum length for an internet name
 */
const MaxInternetName = MaxEmailName + MaxDomainName + 1;

/**
 * Maximum length for an internet name for IMCEA-encapsulated X400 addresses.
 */
const MaxX400InternetName = MaxX400EmailName + MaxDomainName + 1;

/**
 * Parses and validates a given address per the rules specified in the RFC821
 * @param address Address to validate
 * @param checkLength If true, this method validates the length of smtp address and its individual parts
 * @param allowUTF8 If true, allow UTF8 characters in the email address.
 * @returns tuple containing boolean indicating whether address valid and number indicating start of domain part
 */
function IsValidSmtpAddress(
    address: string,
    checkLength: boolean,
    allowUTF8: boolean
): [boolean, number] {
    if (isStringNullOrWhiteSpace(address)) {
        // null address...
        return [false, -1];
    }

    if (checkLength && address.length > MaxInternetName) {
        if (address.length > MaxX400InternetName || !IsEncapsulatedX400Address(address)) {
            // exceeds SMTP limits...
            return [false, -1];
        }
    }

    let offset = 0;
    let state = ValidationStage.BEGIN;
    while (offset < address.length && state != ValidationStage.ERROR) {
        const ch = address.charAt(offset);
        const charCode = address.charCodeAt(offset);
        offset++;

        switch (state) {
            case ValidationStage.BEGIN:
                if ((ch < '\x80' && IsAtom(charCode)) || (ch >= '\x80' && allowUTF8)) {
                    state = ValidationStage.LOCAL;
                    continue;
                }
                if (ch == '\\') {
                    state = ValidationStage.LOCAL_ESC;
                    continue;
                }
                if (ch == '"') {
                    state = ValidationStage.LOCAL_DQS;
                    continue;
                }

                // error...
                break;

            case ValidationStage.LOCAL:
                if (ch == '@') {
                    state = ValidationStage.DOMAIN;
                    offset--;
                    continue;
                }
                if (ch == '.') {
                    state = ValidationStage.LOCAL_DOT;
                    continue;
                }

                // fall through...
                state = ValidationStage.LOCAL_DOT;
                offset--;
                continue;

            case ValidationStage.LOCAL_DOT:
                if ((ch < '\x80' && IsAtom(charCode)) || (ch >= '\x80' && allowUTF8)) {
                    state = ValidationStage.LOCAL;
                    continue;
                }

                if (ch == '\\') {
                    state = ValidationStage.LOCAL_ESC;
                    continue;
                }

                // error...
                break;

            case ValidationStage.LOCAL_ESC:
                // RFC 821:

                // <local-part> ::= <dot-string> | <quoted-string>
                // <dot-string> ::= <string> | <string> "." <dot-string>
                // <string> ::= <char> | <char> <string>
                // <char> ::= <c> | "\" <x>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                if (ch < '\x80' || (ch >= '\x80' && allowUTF8)) {
                    state = ValidationStage.LOCAL;
                    continue;
                }

                // error...
                break;

            case ValidationStage.LOCAL_DQS:
                if (ch == '"') {
                    state = ValidationStage.LOCAL_DQS_END;
                    continue;
                }
                if (ch == '\\') {
                    state = ValidationStage.LOCAL_DQS_ESC;
                    continue;
                }

                // RFC 821:

                // <local-part> ::= <dot-string> | <quoted-string>
                // <quoted-string> ::=  """ <qtext> """
                // <qtext> ::=  "\" <x> | "\" <x> <qtext> | <q> | <q> <qtext>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                // <q> ::= any one of the 128 ASCII characters except <CR>,
                //           <LF>, quote ("), or backslash (\)

                // RFC 2821 is more restrictive on this, but we need to support old RFC821
                // With RFC 6530 adding support of UTF8 characters in the value
                if (
                    (ch < '\x80' && '\r' != ch && '\n' != ch && '\\' != ch && '"' != ch) ||
                    (ch >= '\x80' && allowUTF8)
                ) {
                    state = ValidationStage.LOCAL_DQS;
                    continue;
                }

                // error...
                break;

            case ValidationStage.LOCAL_DQS_ESC:
                // RFC 821:

                // <local-part> ::= <dot-string> | <quoted-string>
                // <quoted-string> ::=  """ <qtext> """
                // <qtext> ::=  "\" <x> | "\" <x> <qtext> | <q> | <q> <qtext>
                // <x> ::= any one of the 128 ASCII characters (no exceptions)
                // <q> ::= any one of the 128 ASCII characters except <CR>,
                //           <LF>, quote ("), or backslash (\)
                if (ch < '\x80' || (ch >= '\x80' && allowUTF8)) {
                    state = ValidationStage.LOCAL_DQS;
                    continue;
                }

                // error...
                break;

            case ValidationStage.LOCAL_DQS_END:
                if (ch == '@') {
                    state = ValidationStage.DOMAIN;
                    offset--;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN:
                // nameLength includes the count of the '@' character
                if (checkLength && offset - 1 > MaxEmailName) {
                    if (offset - 1 > MaxX400EmailName || !IsEncapsulatedX400Address(address)) {
                        // exceeds SMTP limits...
                        return [false, -1];
                    }
                }

                if (IsValidDomain(address, offset, checkLength, allowUTF8)) {
                    return [true, offset];
                }

                // error...
                break;

            default:
                //Debug.Assert(false, 'unexpected');
                break;
        }

        state = ValidationStage.ERROR;
    }

    return [false, -1];
}

/**
 * Validates a given domain per the rules specified in the RFC821
 * @param address the domain
 * @param offset domain start offset in array
 * @param checkLength If true, this method validates the length of smtp address and its individual parts
 * @param allowUTF8 Whether the address should be parsed as an international (non-ASCII) address.
 * @returns whether domain is valid
 */
function IsValidDomain(address: string, offset: number, checkLength: boolean, allowUTF8: boolean) {
    if (
        isStringNullOrWhiteSpace(address) ||
        (checkLength && address.length - offset > MaxDomainName)
    ) {
        // empty or exceeds SMTP limits...
        return false;
    }

    let state = ValidationStage.DOMAIN;

    // domain literal validation variables
    // ... Group is a sequence of digits or hex digits . Groups are composed into address literal with
    //   appropriate delimiters.
    let group = 0; // number of groups found
    let groupChars = 0; // number of characters in the current group
    let currentGroup = 0; // value of the current group, used to check the group in ipv4 address <= 255
    let compressedIpv6 = false; // compressed form of IPv6 address found
    let subDomainStart = 0;
    let isSingleLabelDomain = true;

    while (offset < address.length && state != ValidationStage.ERROR) {
        const ch = address.charAt(offset);
        const charCode = address.charCodeAt(offset);
        offset++;

        switch (state) {
            case ValidationStage.DOMAIN:
                if (ch == '[') {
                    state = ValidationStage.DOMAIN_LITERAL;
                    continue;
                }

                // NOTE: per RFC 2821 underscore is not allowed in a sub-domain name and
                // sub-domain name cannot start with hyphen. But... Exchange transport
                // allows underscore and hyphen anywhere in sub-domain name.
                // So we will do what transport does and allow these characters.
                // See RAID 227719 for reference.
                if (
                    (ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_'
                ) {
                    subDomainStart = offset;
                    state = ValidationStage.DOMAIN_SUB;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_SUB:
                if (ch == '.') {
                    if (checkLength && offset - subDomainStart > MaxSubDomainName) {
                        // exceeds SMTP limits...
                        return false;
                    }
                    isSingleLabelDomain = false;
                    state = ValidationStage.DOMAIN_DOT;
                    continue;
                }
                if (
                    (ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_'
                ) {
                    state = ValidationStage.DOMAIN_SUB;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_DOT:
                if (
                    (ch < '\x80' && IsAlphaOrDigit(charCode)) ||
                    (ch >= '\x80' && allowUTF8) ||
                    ch == '-' ||
                    ch == '_'
                ) {
                    subDomainStart = offset;
                    state = ValidationStage.DOMAIN_SUB;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL:
                if (ch < '\x80' && IsDigit(charCode)) {
                    state = ValidationStage.DOMAIN_LITERAL_IPV4;
                    group = 1;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    continue;
                }
                if (ch == 'I' || ch == 'i') {
                    state = ValidationStage.DOMAIN_LITERAL_I;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV4:
                if (ch < '\x80' && IsDigit(charCode) && groupChars < 3) {
                    groupChars++;
                    currentGroup = currentGroup * 10 + parseInt('' + ch);
                    if (currentGroup > 255) {
                        // error...
                        break;
                    }

                    state = ValidationStage.DOMAIN_LITERAL_IPV4;
                    continue;
                }
                if (ch == '.') {
                    state = ValidationStage.DOMAIN_LITERAL_IPV4_DOT;
                    continue;
                }
                if (ch == ']' && group == 4) {
                    state = ValidationStage.DOMAIN_LITERAL_END;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV4_DOT:
                if (ch < '\x80' && IsDigit(charCode) && group < 4) {
                    group++;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    state = ValidationStage.DOMAIN_LITERAL_IPV4;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_I:
                if (ch == 'P' || ch == 'p') {
                    state = ValidationStage.DOMAIN_LITERAL_IP;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IP:
                if (ch == 'v' || ch == 'V') {
                    state = ValidationStage.DOMAIN_LITERAL_IPV;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV:
                if (ch == '6') {
                    state = ValidationStage.DOMAIN_LITERAL_IPV6;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6:
                if (ch == ':') {
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6_:
                if (ch < '\x80' && IsHex(charCode)) {
                    compressedIpv6 = false;
                    group = 1;
                    groupChars = 1;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_GRP;
                    continue;
                }
                if (ch == ':') {
                    group = 0;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_STARTCOLON;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6_STARTCOLON:
                if (ch == ':') {
                    compressedIpv6 = true;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_COMP;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6_GRP:
                if (ch < '\x80' && IsHex(charCode) && groupChars < 4) {
                    groupChars++;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_GRP;
                    continue;
                }
                if (ch == ':') {
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_COLON;
                    continue;
                }
                if (
                    ch == ']' &&
                    ((!compressedIpv6 && group == 8) || (compressedIpv6 && group <= 6))
                ) {
                    state = ValidationStage.DOMAIN_LITERAL_END;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6_V4GRP:
                if (ch < '\x80' && IsDigit(charCode) && groupChars < 3) {
                    groupChars++;
                    currentGroup = currentGroup * 10 + parseInt('' + ch);
                    state =
                        currentGroup <= 255
                            ? ValidationStage.DOMAIN_LITERAL_IPV6_V4GRP
                            : ValidationStage.DOMAIN_LITERAL_IPV6_GRP;
                    continue;
                }
                if (ch < '\x80' && IsHex(charCode) && groupChars < 4) {
                    groupChars++;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_GRP;
                    continue;
                }
                if (ch == ':') {
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_COLON;
                    continue;
                }
                if (ch == '.') {
                    group = 1; // we saw one IPv4 group
                    state = ValidationStage.DOMAIN_LITERAL_IPV4_DOT;
                    continue;
                }
                if (ch == ']' && compressedIpv6 && group <= 6) {
                    state = ValidationStage.DOMAIN_LITERAL_END;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6_COLON:
                // check: parentheses...
                if (
                    (ch < '\x80' && IsDigit(charCode) && (!compressedIpv6 && group == 6)) ||
                    (compressedIpv6 && group <= 4)
                ) {
                    // can have ipv4 addr at the end
                    group++;
                    groupChars = 1;
                    currentGroup = parseInt('' + ch);
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_V4GRP;
                    continue;
                }

                // check: parentheses...
                if (
                    (ch < '\x80' && IsHex(charCode) && (!compressedIpv6 && group < 8)) ||
                    (compressedIpv6 && group < 6)
                ) {
                    group++;
                    groupChars = 1;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_GRP;
                    continue;
                }
                if (ch == ':' && !compressedIpv6 && group <= 6) {
                    compressedIpv6 = true;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_COMP;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_IPV6_COMP:
                if (ch < '\x80' && IsHex(charCode) && group < 6) {
                    group++;
                    groupChars = 1;
                    state = ValidationStage.DOMAIN_LITERAL_IPV6_GRP;
                    continue;
                }
                if (ch == ']') {
                    state = ValidationStage.DOMAIN_LITERAL_END;
                    continue;
                }

                // error...
                break;

            case ValidationStage.DOMAIN_LITERAL_END:
                // any input in ValidationStage.DOMAIN_LITERAL_END state is an error
                break;

            default:
                //Debug.Assert(false, 'unexpected');
                break;
        }

        state = ValidationStage.ERROR;
    }

    // domain is good if we are in one of valid end states
    return (
        state == ValidationStage.DOMAIN_LITERAL_END ||
        (state == ValidationStage.DOMAIN_SUB &&
            (!checkLength || offset - subDomainStart < MaxSubDomainName) &&
            !isSingleLabelDomain)
    );
}

function IsEncapsulatedX400Address(address: string) {
    return address.toUpperCase().lastIndexOf('IMCEAX400-', 0) === 0;
}

function IsAtom(ch: number): boolean {
    return 0 != (Dictionary[ch] & Token.Atom);
}

function IsHex(ch: number): boolean {
    return 0 != (Dictionary[ch] & Token.Hex);
}

function IsDigit(ch: number): boolean {
    return 0 != (Dictionary[ch] & Token.Digit);
}

function IsAlphaOrDigit(ch: number): boolean {
    return 0 != (Dictionary[ch] & (Token.Digit | Token.Alpha));
}
